var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('submenu-page',{attrs:{"eyebrow":"RECORDS MANAGEMENT","title":"Document Management","description":"Store and review documents associated with student and staff records.","count-label":"document tools"}},[_c('SubMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }